/**
 * Form Modal Component
 * Provides consistent form modal structure with actions
 */

import React from 'react';
import BaseModal from './BaseModal';
import FormActions from './FormActions';

export interface FormModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel?: () => void;
  onReset?: () => void;
  title?: string;
  children: React.ReactNode;
  width?: string;
  submitLabel?: string;
  cancelLabel?: string;
  resetLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  showCancel?: boolean;
  showReset?: boolean;
  submitVariant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'ghost';
  cancelVariant?: 'ghost' | 'secondary' | 'outline';
  resetVariant?: 'ghost' | 'secondary' | 'outline';
  className?: string;
}

const FormModal: React.FC<FormModalProps> = ({
  open,
  onClose,
  onSubmit,
  onCancel,
  onReset,
  title,
  children,
  width = 'max-w-lg',
  submitLabel = 'حفظ',
  cancelLabel = 'إلغاء',
  resetLabel = 'إعادة تعيين',
  isLoading = false,
  disabled = false,
  showCancel = true,
  showReset = false,
  submitVariant = 'primary',
  cancelVariant = 'ghost',
  resetVariant = 'ghost',
  className = ''
}) => {
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={title}
      width={width}
      className={className}
    >
      <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
        <div className="space-y-6">
          {children}
        </div>

        <FormActions
          onSubmit={onSubmit}
          onCancel={handleCancel}
          onReset={onReset}
          submitLabel={submitLabel}
          cancelLabel={cancelLabel}
          resetLabel={resetLabel}
          isLoading={isLoading}
          disabled={disabled}
          showCancel={showCancel}
          showReset={showReset}
          submitVariant={submitVariant}
          cancelVariant={cancelVariant}
          resetVariant={resetVariant}
          className="mt-6"
        />
      </form>
    </BaseModal>
  );
};

export default FormModal;
